import React from 'react';

const PhotoFrame = ({ src, alt, className, containerClassName }) => {
  const clipPathStyle = {
    clipPath: 'inset(0% round 35px 35px 35px 15px)',
  };

  return (
    <div
      className={`tw-relative tw-overflow-hidden tw-shadow-lg ${containerClassName || ''}`}
      style={clipPathStyle}
    >
      <img
        src={src}
        alt={alt}
        className={`tw-w-full tw-h-full tw-object-cover ${className || ''}`}
      />
    </div>
  );
};

export default PhotoFrame;
